import * as yup from 'yup';

import { ProductType } from '../types/types';

const imageFieldSchema = yup.object({
  preview: yup.string().required('A imagem é obrigatória'),
  file: yup.mixed().optional(),
});

const programImagesSchema = yup.object({
  card: imageFieldSchema,
  logo: imageFieldSchema,
  vertical: imageFieldSchema,
});

const comboImagesSchema = yup.object({
  main: imageFieldSchema,
  search: imageFieldSchema,
  highlight: yup.object({
    original: imageFieldSchema,
    small: imageFieldSchema,
  }),
});

export const creationSchema = yup.object({
  productType: yup
    .string()
    .oneOf([ProductType.Program, ProductType.Combo])
    .required('O tipo de item é obrigatório'),
  title: yup
    .string()
    .required('O nome é obrigatório')
    .max(80, 'Máximo de 80 caracteres'),
  description: yup.string().max(500, 'Máximo de 500 caracteres').optional(),
  categoryIds: yup
    .array()
    .of(yup.number().required())
    .min(1, 'Selecione pelo menos uma categoria')
    .max(1, 'Selecione apenas uma categoria')
    .required('Selecione uma categoria'),
  buttonText: yup.string().when('productType', {
    is: ProductType.Combo,
    then: schema => schema.required('O nome do botão é obrigatório'),
    otherwise: schema => schema.optional(),
  }),
  laneIds: yup
    .array()
    .of(yup.number().required())
    .min(1, 'Selecione uma raia de exibição')
    .required('Selecione uma raia de exibição'),
  images: yup.mixed().when('productType', {
    is: ProductType.Program,
    then: () => yup.object({ program: programImagesSchema }),
    otherwise: () => yup.object({ combo: comboImagesSchema }),
  }),
});

export type CreationFormData = yup.InferType<typeof creationSchema>;

export const creationDefaultValues: CreationFormData = {
  productType: ProductType.Program,
  title: '',
  description: '',
  buttonText: '',
  categoryIds: [],
  laneIds: [],
  images: {
    program: {
      card: { preview: '', file: undefined },
      logo: { preview: '', file: undefined },
      vertical: { preview: '', file: undefined },
    },
    combo: {
      main: { preview: '', file: undefined },
      search: { preview: '', file: undefined },
      highlight: {
        original: { preview: '', file: undefined },
        small: { preview: '', file: undefined },
      },
    },
  },
};
